import React from "react";

/**
 * Delete message confirmation dialog.
 *
 * @param {object} props
 * @param {object} props.message - Message to delete
 * @param {function} props.onConfirm - Confirm delete handler
 * @param {function} props.onCancel - Cancel handler
 */
export default function ChatConfirmDelete({ message, onConfirm, onCancel }) {
  if (!message) return null;

  return (
    <div className="chat-action-modal" onClick={onCancel}>
      <div className="chat-action-modal__dialog" onClick={(e) => e.stopPropagation()}>
        <div className="chat-action-modal__title">Удалить сообщение?</div>
        <div className="chat-action-modal__text">Это действие нельзя отменить.</div>
        <div className="chat-action-modal__actions">
          <button
            type="button"
            className="chat-action-modal__btn chat-action-modal__btn--cancel"
            onClick={onCancel}
          >
            Отмена
          </button>
          <button
            type="button"
            className="chat-action-modal__btn chat-action-modal__btn--danger"
            onClick={onConfirm}
          >
            Удалить
          </button>
        </div>
      </div>
    </div>
  );
}
